import _classCallCheck from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/createSuper.js";
// Copyright 2017-2022 @polkadot/types-codec authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { WrapperKeepOpaque } from "./WrapperKeepOpaque.js";
export var WrapperOpaque = /*#__PURE__*/function (_WrapperKeepOpaque) {
  _inherits(WrapperOpaque, _WrapperKeepOpaque);

  var _super = _createSuper(WrapperOpaque);

  function WrapperOpaque(registry, typeName, value) {
    _classCallCheck(this, WrapperOpaque);

    return _super.call(this, registry, typeName, value, {
      opaqueName: 'WrapperOpaque'
    });
  }

  _createClass(WrapperOpaque, [{
    key: "inner",
    get:
    /**
     * @description The inner value for this wrapper, in all cases it _should_ be decodable (unlike KeepOpaque)
     */
    function get() {
      return this.unwrap();
    }
  }], [{
    key: "with",
    value: function _with(Type) {
      return /*#__PURE__*/function (_WrapperOpaque) {
        _inherits(_class, _WrapperOpaque);

        var _super2 = _createSuper(_class);

        function _class(registry, value) {
          _classCallCheck(this, _class);

          return _super2.call(this, registry, Type, value);
        }

        return _createClass(_class);
      }(WrapperOpaque);
    }
  }]);

  return WrapperOpaque;
}(WrapperKeepOpaque);